var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "h-100 d-flex flex-column",
      on: {
        dragover: function($event) {
          $event.preventDefault()
        },
        drop: function($event) {
          $event.preventDefault()
          return _vm.fileDropHandler($event)
        }
      }
    },
    [
      _c("div", { staticClass: "py-2 px-4 bottom-border" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "div",
            {
              staticClass: "flex-grow-1 mr-2",
              staticStyle: { "font-size": "18px" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.task.task_name,
                    expression: "task.task_name"
                  }
                ],
                staticClass: "form-control-title w-100 pl-0",
                attrs: { type: "text" },
                domProps: { value: _vm.task.task_name },
                on: {
                  change: _vm.saveTask,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.task, "task_name", $event.target.value)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "mr-3",
              staticStyle: { "font-size": "20px" },
              attrs: { href: "javascript:;" },
              on: { click: _vm.toggleRead }
            },
            [
              _c("i", {
                class: _vm.task.task_read
                  ? "fa fa-envelope-open"
                  : "fa fa-envelope"
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "font-red mr-3",
              staticStyle: { "font-size": "20px" },
              attrs: { href: "javascript:;" },
              on: { click: _vm.deleteTaskAsk }
            },
            [_c("i", { staticClass: "fa fa-trash" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticStyle: { "font-size": "20px" },
              attrs: { href: "javascript:;" },
              on: { click: _vm.closeTask }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex w-100 mt-1" }, [
          _c("div", { staticClass: "text-left" }, [
            _vm.task.task_deadline_date != null
              ? _c(
                  "div",
                  { staticClass: "mt-1", staticStyle: { "font-size": "16px" } },
                  [
                    _c("b", [_vm._v("NB de jours avant échéance")]),
                    _vm._v(": " + _vm._s(_vm.daysBeforeDeadline) + "\n        ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.task.task_deadline_date != null
              ? _c(
                  "div",
                  { staticClass: "mt-1", staticStyle: { "font-size": "16px" } },
                  [
                    _c("b", [_vm._v("Date d'échéance")]),
                    _vm._v(
                      ": " + _vm._s(_vm.task.task_deadline_date) + "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.task.task_deadline_date != null
              ? _c("hr", {
                  staticClass: "my-2",
                  staticStyle: { "border-top": "1px solid #aaa" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1 position-relative" }, [
              _vm.task.project_name != null
                ? _c("span", [
                    _c("b", [_vm._v("Projet")]),
                    _vm._v(": "),
                    _c("a", { attrs: { href: _vm.projectLink } }, [
                      _vm._v(
                        _vm._s(_vm.task.project_number) +
                          " • " +
                          _vm._s(_vm.task.project_name)
                      )
                    ])
                  ])
                : _c("span", [
                    _c("b", [_vm._v("Projet")]),
                    _vm._v(": "),
                    _c("em", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:;" },
                          on: { click: function($event) {} }
                        },
                        [_vm._v("(non défini)")]
                      )
                    ])
                  ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "position-absolute",
                staticStyle: { top: "30px", left: "0" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1" }, [
              _c("b", [_vm._v("Chargé de projet du client")]),
              _vm._v(
                ": " +
                  _vm._s(_vm.task.project_project_manager_contact_name) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1" }, [
              _c("b", [_vm._v("Responsable du projet")]),
              _vm._v(": " + _vm._s(_vm.task.project_user_name) + "\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1" }, [
              _c("b", [_vm._v("Crée par")]),
              _vm._v(": " + _vm._s(_vm.task.user_name) + "\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-1" }, [
              _c("b", [_vm._v("Crée le")]),
              _vm._v(
                ": " +
                  _vm._s(_vm.longTimestamp(_vm.task.task_creation_datetime)) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-right flex-grow-1" }, [
            _c(
              "div",
              { staticClass: "d-flex w-100" },
              [
                _c(
                  "label",
                  {
                    staticClass: "my-0 mr-1 text-right flex-grow-1",
                    staticStyle: { "line-height": "30px" }
                  },
                  [_vm._v("Date début:")]
                ),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { size: "small" },
                  on: { change: _vm.startDateChanged },
                  model: {
                    value: _vm.task.task_start_date,
                    callback: function($$v) {
                      _vm.$set(_vm.task, "task_start_date", $$v)
                    },
                    expression: "task.task_start_date"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex w-100 mt-1" },
              [
                _c(
                  "label",
                  {
                    staticClass: "my-0 mr-1 text-right flex-grow-1",
                    staticStyle: { "line-height": "30px" }
                  },
                  [_vm._v("Date d'échéance:")]
                ),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { size: "small" },
                  on: { change: _vm.deadlineDateChanged },
                  model: {
                    value: _vm.task.task_deadline_date,
                    callback: function($$v) {
                      _vm.$set(_vm.task, "task_deadline_date", $$v)
                    },
                    expression: "task.task_deadline_date"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex w-100 mt-1" },
              [
                _c(
                  "label",
                  {
                    staticClass: "my-0 mr-1 text-right flex-grow-1",
                    staticStyle: { "line-height": "30px" }
                  },
                  [_vm._v("Date rappel:")]
                ),
                _vm._v(" "),
                _c("date-picker", {
                  attrs: { size: "small" },
                  on: { change: _vm.saveTask },
                  model: {
                    value: _vm.task.task_remind_date,
                    callback: function($$v) {
                      _vm.$set(_vm.task, "task_remind_date", $$v)
                    },
                    expression: "task.task_remind_date"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex w-100 mt-1" }, [
              _c(
                "label",
                {
                  staticClass: "my-0 mr-1 text-right flex-grow-1",
                  staticStyle: { "line-height": "30px" }
                },
                [_vm._v("% avancement:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.task.task_progress,
                    expression: "task.task_progress"
                  }
                ],
                staticClass: "form-control input-sm input-xsmall",
                attrs: { type: "number" },
                domProps: { value: _vm.task.task_progress },
                on: {
                  change: _vm.saveTask,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.task, "task_progress", $event.target.value)
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex bottom-border" }, [
        _c("div", { staticStyle: { "border-right": "1px solid #ccc" } }, [
          _c("div", { staticStyle: { width: "5px" } }),
          _vm._v(" "),
          _c("div", { staticClass: "p-0" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.task.task_state_id,
                    expression: "task.task_state_id"
                  }
                ],
                staticClass: "form-control",
                staticStyle: { border: "none", "min-width": "125px" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.task,
                        "task_state_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.saveTask
                  ]
                }
              },
              _vm._l(_vm.states, function(state, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: state.task_state_id } },
                  [_vm._v(_vm._s(state.task_state_name))]
                )
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1", staticStyle: { padding: "2px" } },
          [
            _vm._l(_vm.task.assignees, function(assignee, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "task-assignee",
                  style: { backgroundColor: assignee.user_background_color }
                },
                [
                  _c("span", [_vm._v(_vm._s(assignee.user_name))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "task-assignee-delete",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.unassignUser(assignee, "assignee")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" })]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "task-assignee task-assignee-add",
                on: { click: _vm.showAddAssigneeSelect }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { padding: "2px 15px" } }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm",
              class: { green: _vm.historyToggled },
              on: {
                click: function($event) {
                  _vm.historyToggled = !_vm.historyToggled
                }
              }
            },
            [_vm._v("Historique")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex bottom-border" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1", staticStyle: { padding: "2px" } },
          [
            _vm._l(_vm.task.distributors, function(distributor, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "task-assignee",
                  style: { backgroundColor: distributor.user_background_color }
                },
                [
                  _c("span", [_vm._v(_vm._s(distributor.user_name))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "task-assignee-delete",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.unassignUser(distributor, "distributor")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" })]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "task-assignee task-assignee-add",
                on: { click: _vm.showAddDistributorSelect }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      !_vm.historyToggled
        ? _c(
            "div",
            {
              ref: "scrollable-content",
              staticClass: "flex-grow-1",
              staticStyle: { "overflow-y": "auto" }
            },
            [
              _c(
                "div",
                [
                  _c("quill", {
                    ref: "quill-editor",
                    staticClass: "h-100",
                    attrs: {
                      uploadHander: _vm.handleFileUploadFromDrop,
                      showToolbar: true,
                      allowDragAndDrop: true,
                      allowImages: true,
                      hasEmojis: false
                    },
                    on: { change: _vm.saveTask },
                    model: {
                      value: _vm.task.task_description,
                      callback: function($$v) {
                        _vm.$set(_vm.task, "task_description", $$v)
                      },
                      expression: "task.task_description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "task-manager-files-section position-relative" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      staticStyle: {
                        position: "absolute",
                        top: "-10px",
                        left: "0",
                        width: "100%",
                        "font-size": "12px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "px-1",
                          staticStyle: { "background-color": "white" }
                        },
                        [
                          _vm._v(
                            "Fichiers (" + _vm._s(_vm.task.files.length) + ")"
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-2" },
                    _vm._l(_vm.task.files, function(file, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "task-manager-wrapper",
                          attrs: {
                            href: _vm.filePreviewLink(file),
                            target: "_blank"
                          }
                        },
                        [
                          _c("div", { staticClass: "task-manager-file" }, [
                            _c(
                              "div",
                              { staticClass: "task-manager-file-thumbnail" },
                              [
                                _vm.isFileImage(file)
                                  ? _c(
                                      "fancy-box",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%"
                                        },
                                        attrs: {
                                          href: _vm.fileAttachmentImage(file)
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            "object-fit": "contain"
                                          },
                                          attrs: {
                                            src: _vm.fileAttachmentThumbnail(
                                              file
                                            ),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _vm.isFilePdf(file) || _vm.isFileText(file)
                                  ? _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          display: "block"
                                        },
                                        attrs: {
                                          href: _vm.filePreviewLink(file),
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            "object-fit": "contain"
                                          },
                                          attrs: {
                                            src: _vm.fileAttachmentThumbnail(
                                              file
                                            ),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          display: "block"
                                        },
                                        attrs: { href: "javascript:;" },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadFile(file)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            "object-fit": "contain"
                                          },
                                          attrs: {
                                            src: _vm.fileAttachmentThumbnail(
                                              file
                                            ),
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-grow-1 h-100" }, [
                              _c("div", { staticClass: "bold" }, [
                                _vm._v(_vm._s(file.task_file_title))
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "font-grey-gallery mr-2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.shortTimestamp(
                                          file.task_file_attachment_datetime
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadFile(file)
                                        }
                                      }
                                    },
                                    [_vm._v("Télécharger")]
                                  ),
                                  _vm._v(" - \n                  "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "font-red",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteFileAsk(file, $event)
                                        }
                                      }
                                    },
                                    [_vm._v("Supprimer")]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.triggerFileUploadClick }
                      },
                      [_vm._v("Télécharger un fichier")]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "task-manager-comment-section position-relative"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      staticStyle: {
                        position: "absolute",
                        top: "-10px",
                        left: "0",
                        width: "100%",
                        "font-size": "12px"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "px-1",
                          staticStyle: { "background-color": "white" }
                        },
                        [
                          _vm._v(
                            "Commentaires (Affichage " +
                              _vm._s(_vm.task.loaded_comment_count) +
                              " / " +
                              _vm._s(_vm.task.total_comments) +
                              ")"
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.fetchingComments
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "text-center p-3 font-grey-gallery" },
                          [_vm._v("Obtention des commentaires...")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.comments.length == 0 && !_vm.fetchingComments
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "text-center p-3 font-grey-gallery" },
                          [_vm._v("Aucun commentaires à afficher")]
                        )
                      ])
                    : _c(
                        "div",
                        [
                          _vm.canLoadMore
                            ? _c(
                                "div",
                                { staticClass: "text-center px-2 pb-2 pt-3" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:;" },
                                      on: { click: _vm.loadMoreComments }
                                    },
                                    [_vm._v("Charger plus de commentaires")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.reversedComments, function(
                            message,
                            index
                          ) {
                            return _c("feed-message", {
                              key: index,
                              attrs: {
                                message: message,
                                fileAttachmentImageUrl:
                                  "task/files/%fileid%/image",
                                fileAttachmentThumbnailUrl:
                                  "task/files/%fileid%/thumbnail",
                                fileAttachmentDownloadUrl:
                                  "task/files/%fileid%/download"
                              },
                              on: {
                                resendMessage: function($event) {
                                  return _vm.submitComment($event, true)
                                },
                                deleteMessage: _vm.deleteComment
                              }
                            })
                          })
                        ],
                        2
                      )
                ]
              )
            ]
          )
        : _c(
            "div",
            {
              ref: "scrollable-content",
              staticClass: "flex-grow-1 pb-3",
              staticStyle: { "overflow-y": "auto" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "task-manager-comment-section position-relative"
                },
                [
                  _vm.fetchingHistory
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "text-center p-3 font-grey-gallery" },
                          [_vm._v("Chargement de l'historique...")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task.history.length == 0 && !_vm.fetchingHistory
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "text-center p-3 font-grey-gallery" },
                          [_vm._v("L'historique est vide")]
                        )
                      ])
                    : _c(
                        "div",
                        [
                          _vm.canLoadMore
                            ? _c(
                                "div",
                                { staticClass: "text-center px-2 pb-2 pt-3" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:;" },
                                      on: { click: _vm.loadMoreHistory }
                                    },
                                    [_vm._v("Charger plus d'éléments")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.reversedHistory, function(history, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "task-manager-comment",
                                class: {
                                  "my-comment": _vm.isMyHistory(history)
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "avatar",
                                    style: {
                                      backgroundColor:
                                        history.history_user_background_color
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(history.history_user_initials) +
                                        " "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-wrapper mx-2 position-relative"
                                  },
                                  [
                                    _c("div", { staticClass: "px-3 pt-2" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(history.history_user_name)
                                        )
                                      ]),
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#777" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.shortTimestamp(
                                                history.history_datetime
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "px-3 pb-2 pt-1" },
                                      [
                                        history.history_type == "1"
                                          ? _c(
                                              "table",
                                              { staticClass: "mt-2" },
                                              [
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._m(1, true),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      history.details,
                                                      function(
                                                        history_detail,
                                                        index2
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              index +
                                                              "-" +
                                                              index2 +
                                                              "-0"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "bold pr-2",
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.__(
                                                                      "audit_detail_" +
                                                                        history_detail.audit_field
                                                                    )
                                                                  ) + ":"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            history_detail.audit_new_value !=
                                                              "" &&
                                                            history_detail.audit_new_value !=
                                                              null
                                                              ? _c("td", {
                                                                  staticStyle: {
                                                                    "vertical-align":
                                                                      "top"
                                                                  },
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      history_detail.audit_new_value
                                                                    )
                                                                  }
                                                                })
                                                              : _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "italic font-grey-gallery"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(vide)"
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          : history.history_type == "2"
                                          ? _c(
                                              "table",
                                              { staticClass: "mt-2" },
                                              [
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._m(2, true),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      history.details,
                                                      function(
                                                        history_detail,
                                                        index2
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              index +
                                                              "-" +
                                                              index2 +
                                                              "-1"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "bold pr-2",
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.__(
                                                                      "audit_detail_" +
                                                                        history_detail.audit_field
                                                                    )
                                                                  ) + ":"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            history_detail.audit_old_value !=
                                                              "" &&
                                                            history_detail.audit_old_value !=
                                                              null
                                                              ? _c("td", {
                                                                  staticStyle: {
                                                                    "vertical-align":
                                                                      "top"
                                                                  },
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      history_detail.audit_old_value
                                                                    )
                                                                  }
                                                                })
                                                              : _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "italic font-grey-gallery"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(vide)"
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._m(3, true),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      history.details,
                                                      function(
                                                        history_detail,
                                                        index2
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              index +
                                                              "-" +
                                                              index2 +
                                                              "-2"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "bold pr-2",
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.__(
                                                                      "audit_detail_" +
                                                                        history_detail.audit_field
                                                                    )
                                                                  ) + ":"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            history_detail.audit_new_value !=
                                                              "" &&
                                                            history_detail.audit_new_value !=
                                                              null
                                                              ? _c("td", {
                                                                  staticStyle: {
                                                                    "vertical-align":
                                                                      "top"
                                                                  },
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      history_detail.audit_new_value
                                                                    )
                                                                  }
                                                                })
                                                              : _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "italic font-grey-gallery"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(vide)"
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          : history.history_type == "3"
                                          ? _c(
                                              "table",
                                              { staticClass: "mt-2" },
                                              [
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._m(4, true),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      history.details,
                                                      function(
                                                        history_detail,
                                                        index2
                                                      ) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key:
                                                              index +
                                                              "-" +
                                                              index2 +
                                                              "-3"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "bold pr-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.__(
                                                                      "audit_detail_" +
                                                                        history_detail.audit_field
                                                                    )
                                                                  ) + ":"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            history_detail.audit_old_value !=
                                                              "" &&
                                                            history_detail.audit_old_value !=
                                                              null
                                                              ? _c("td", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      history_detail.audit_old_value
                                                                    )
                                                                  }
                                                                })
                                                              : _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "italic font-grey-gallery"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(vide)"
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                ]
              )
            ]
          ),
      _vm._v(" "),
      !_vm.historyToggled
        ? _c("div", { staticClass: "task-manager-compose-comment" }, [
            _c(
              "div",
              {
                staticClass: "avatar",
                style: { backgroundColor: _vm.user.user_background_color }
              },
              [_vm._v(" " + _vm._s(_vm.user.user_initials) + " ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-2 flex-grow-1 position-relative" },
              [
                _c("fancy-textarea-box", {
                  ref: "comment-box",
                  on: {
                    enterPressed: _vm.sendComment,
                    toolClick: _vm.toolClick
                  },
                  model: {
                    value: _vm.current_comment,
                    callback: function($$v) {
                      _vm.current_comment = $$v
                    },
                    expression: "current_comment"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddAssigneeContainer
        ? _c(
            "div",
            {
              staticClass: "task-manager-fixed-container",
              on: {
                click: function($event) {
                  _vm.showAddAssigneeContainer = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "add-assignee-container",
                  staticStyle: { width: "175px" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("select2", {
                    ref: "add-assignee-select",
                    staticClass: "mx-1",
                    attrs: {
                      placeholder: "Choisir un utilisateur",
                      endpoint: _vm.userSelect2Endpoint,
                      dropdownParent: ".task-manager-fixed-container",
                      attributes: { task_id: _vm.task.task_id }
                    },
                    on: {
                      selected: function($event) {
                        return _vm.addAssigneeSelected($event, "assignee")
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddDistributorContainer
        ? _c(
            "div",
            {
              staticClass: "task-manager-fixed-container",
              on: {
                click: function($event) {
                  _vm.showAddDistributorContainer = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "add-distributor-container",
                  staticStyle: { width: "175px" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("select2", {
                    ref: "add-distributor-select",
                    staticClass: "mx-1",
                    attrs: {
                      placeholder: "Choisir un utilisateur",
                      endpoint: _vm.userSelect2Endpoint,
                      dropdownParent: ".task-manager-fixed-container",
                      attributes: { task_id: _vm.task.task_id }
                    },
                    on: {
                      selected: function($event) {
                        return _vm.addAssigneeSelected($event, "distributor")
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSetCategoryContainer
        ? _c(
            "div",
            {
              staticClass: "task-manager-fixed-container",
              on: {
                click: function($event) {
                  _vm.showSetCategoryContainer = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  ref: "set-category-container",
                  staticStyle: {
                    width: "175px",
                    "background-color": "white",
                    "border-radius": "11px"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                _vm._l(_vm.categories, function(category, index) {
                  return _c("div", { key: index, staticClass: "py-1" }, [
                    _c(
                      "div",
                      {
                        staticClass: "py-1 px-3 text-center clickable",
                        staticStyle: {
                          "border-radius": "100px",
                          "white-space": "nowrap"
                        },
                        style: {
                          color: category.task_category_font_color,
                          backgroundColor:
                            category.task_category_background_color
                        },
                        on: {
                          click: function($event) {
                            return _vm.changeTaskCategory(category)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(category.task_category_name) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "position-absolute",
          staticStyle: { opacity: "0", "pointer-events": "none" }
        },
        [
          _c("input", {
            ref: "task-file-upload",
            attrs: { type: "file", multiple: "" },
            on: { change: _vm.handleFileUploadFromInput }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "text-right",
        staticStyle: {
          "border-right": "1px solid #ccc",
          "min-width": "126px",
          "font-size": "12px"
        }
      },
      [
        _c("div", { staticStyle: { padding: "6px 2px 0 0" } }, [
          _vm._v("Liste de distribution:")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        { staticClass: "bold underline font-blue", attrs: { colspan: "2" } },
        [_vm._v("Création/Ajout")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "bold underline", attrs: { colspan: "2" } }, [
        _vm._v("Avant")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        { staticClass: "bold underline pt-2", attrs: { colspan: "2" } },
        [_vm._v("Après")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        { staticClass: "bold underline font-red", attrs: { colspan: "2" } },
        [_vm._v("Suppression")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }